import { IAdressLight } from 'shared/models/Adress'

export interface ISubleaseList {
  totalCount: number
  totalPageCount: number
  resultCount: number
  morePages: boolean
  currentPage: number
  result: ISubleaseListResult[]
}

export interface ISubleaseListResult {
  id: string
  clientNumber: number
  clientId: string
  clientName: string
  owners: { name: string }[]
  propertySectionNo: string
  fromDate: Date
  toDate: Date
  received: Date
  deadlineAutoApprove: Date
  status: string
  decisionsCount: number
  approverComment: string
  hfProcessedDate: Date
  hfProcessingErrorMessage: string
  previouslySubleasedByOwner: boolean
  applicantName: string
}

export interface ISubleaseFilters {
  searchText: string
  statuses: string[] | null
  previouslySubleasedByOwner: boolean
  sortColumn: string | null
  sortorder: string | null
  take: number
  skip: number
}

export interface ISubleaseApplication {
  applicationId: string
  propertyId: string
  clientId: string
  clientName: string
  clientNumber: number
  propertyAddress: IAdressLight
  propertyNumber: string
  propertySectionNo: string
  period: ISubleasePeriod
  originalEnddate?: Date
  enddateComment: string
  enddDateChanged: Date
  endDateOverrideBy: string
  appliedForEndDateIsChanged: boolean
  lastUpdate: Date
  userRights: ISubleaseUserRights
  existingDecisions: ISubleaseDecision[]
  decisionComment: string
  owners: ISubleaseOwner[]
  specialReason: SubleaseSpecialReason
  specialReasonText: string
  status: string
  currentUsersDecision: ISubleaseDecision
  applicant: ISubleaseOwner
  isAutoApproved: boolean
  tenants: ISubleaseTenant[]
}

export interface ISubleaseUserRights {
  canMakeDecicision: boolean
  canUndoDecision: boolean
}

export interface ISubleaseDecision {
  status: SubleaseStatusEnum
  processedByUser: ISubleaseProcesser
  processedDate: Date
}

export interface ISubleaseProcesser {
  id: string
  name: string
  boardRole: string
  boardRoleDecription: string
}

export interface ISubleaseTenant {
  firstName: string
  lastName: string
  mobile: string
  email: string
  dateOfBirth: Date
}

export interface ISubleaseOwner {
  name: string
  dateOfBirth: Date
  email: string
  mobile: string
  ownerSince: Date
  adress: IAdressLight
}

export interface ISubleasePeriod {
  from: Date
  to: Date
}

export interface IHistoricTenant {
  fromDate: Date
  toDate: Date
  status: 'All' | 'Past' | 'Active' | 'Future'
}

export enum SubleaseSortOrderEnum {
  asc = 'Ascending',
  desc = 'Descending',
}

export enum SubleaseSortFieldEnum {
  status = 'Status',
  clientNumber = 'ClientNumber',
  dateReceived = 'DateReceived',
  deadline = 'Deadline',
  previouslySubleased = 'PreviouslySubleasedByOwner',
  fromDate = 'FromDate',
}

export enum SubleaseStatusEnum {
  rejected = 'Avvist',
  approved = 'Godkjent',
  ongoing = 'TilBehandling',

  // frontend deducted
  conflict = 'Konflikt',
}

export type SubleaseSpecialReason =
  | 'ApplicantIsCompany'
  | 'ApplicantTemporaryAway'
  | 'NewTenantIsFamily'
  | 'RightOfUse'

export type SubleaseDecisionTypes = 'approve' | 'reject'

export interface ISubleaseSettings {
  showSubleaseInPortal: boolean
}
